import { DateTime } from 'luxon';
import { RegistrationType } from '@la/types';
import {
  CombinedCartItemData,
  PaymentPlanSummary,
  StoredBankAccount,
  StoredCreditCard,
  WaiverData,
} from '../Checkout.types';
import { PaymentNetwork } from '../PaymentMethodBadge/PaymentMethodBadgeConfig';

export const mockBankAccount: StoredBankAccount = {
  paymentType: 'ACH',
  storedBankAccountId: 5551212,
  accountType: 'checking',
  bankName: 'First Bank of Astoria',
  createdOn: '2022-10-27T17:18:00',
  last4Digits: '6729',
  isPrimaryPaymentOption: false,
  paymentMethodId: 5551212,
};

export const mockCreditCard: StoredCreditCard = {
  cardType: 'STORED',
  paymentType: 'CARD',
  storedCreditCardId: 9998765,
  createdOn: '2022-10-25T09:34:11',
  expirationDate: '2024-10-01T00:00:00',
  last4Digits: '0000',
  paymentNetwork: PaymentNetwork.Visa,
  isPrimaryPaymentOption: false,
  paymentMethodId: 9998765,
};

export const mockPaymentMethodInfo = {
  storedBankAccounts: [{ ...mockBankAccount, isPrimaryPaymentOption: true }],
  storedCreditCards: [mockCreditCard],
  paymentOptionsCount: 2,
};

export const mockPaymentPlans: PaymentPlanSummary[] = [
  {
    autopayRequired: true,
    dueCheckout: false,
    ngPaymentPlanId: '123',
    name: 'July Special',
    installments: [
      {
        installmentDate: '2026-07-12',
        installmentOrder: 1,
        installmentTotal: '200.00',
        percentage: '34.00',
      },
      {
        installmentDate: '2026-08-12',
        installmentOrder: 2,
        installmentTotal: '200.00',
        percentage: '33.00',
      },
      {
        installmentDate: '2026-09-12',
        installmentOrder: 3,
        installmentTotal: '200.00',
        percentage: '33.00',
      },
    ],
  },
  {
    autopayRequired: false,
    dueCheckout: false,
    ngPaymentPlanId: '789',
    name: 'September Special',
    installments: [
      {
        installmentDate: DateTime.now().toISODate(),
        installmentTotal: '600.00',
        installmentOrder: 1,
        percentage: '100.00',
      },
    ],
  },
];

export const mockCheckoutWaivers: WaiverData[] = [
  {
    content:
      'I hereby waive all liability from the sport organizer. I will participate at my own risk.',
    name: 'Payment Waiver',
    programId: 2343567,
    waiverId: 5787444,
    waiverType: 'PAYMENT',
  },
  {
    content:
      'I hereby waive all liability from the sport organizer. I will participate at my own risk.',
    name: 'Registration Waiver',
    programId: 3265833,
    waiverId: 5787501,
    waiverType: 'REGISTRATION',
  },
];

export const mockCartItemsData: CombinedCartItemData[] = [
  {
    cartItemType: 'TOURNAMENT_TEAM_REGISTRATION',
    cartItemUuid: '01981945-1a77-703a-a4f2-62d855446908',
    editUrl:
      '/app/tournaments/3869183/registration?cartItemUuid=01981945-1a77-703a-a4f2-62d855446908',
    paymentPlanSummaries: [
      {
        autopayRequired: false,
        ngPaymentPlanId: 'ed54a41a-44ee-4817-a633-53f44532d4ab',
        name: 'Costa Rica',
        installments: [
          {
            percentage: '',
            installmentTotal: '200.00',
            installmentDate: '2025-11-13',
            installmentOrder: 1,
          },
          {
            percentage: '100.00',
            installmentTotal: '3200.91',
            installmentDate: '2034-01-05',
            installmentOrder: 2,
          },
        ],
        dueCheckout: false,
        priceAdjustment: {
          percentage: -22,
        },
      },
      {
        autopayRequired: false,
        ngPaymentPlanId: '9e8522ae-876e-4c72-88d0-305928fdacbc',
        name: 'Super plan - X11',
        installments: [
          {
            percentage: '',
            installmentTotal: '800.00',
            installmentDate: '2025-03-21',
            installmentOrder: 1,
          },
          {
            percentage: '100.00',
            installmentTotal: '3360.14',
            installmentDate: '2025-12-20',
            installmentOrder: 2,
          },
        ],
        dueCheckout: false,
        priceAdjustment: {
          fixedAmount: -100,
        },
      },
      {
        autopayRequired: false,
        ngPaymentPlanId: '8b7b6c29-4f9a-4f8c-bbbc-06b91938ca1d',
        name: 'Whatsis',
        installments: [
          {
            percentage: '',
            installmentTotal: '1500.00',
            installmentDate: '2026-02-13',
            installmentOrder: 1,
          },
          {
            percentage: '100.00',
            installmentTotal: '2860.14',
            installmentDate: '2026-09-19',
            installmentOrder: 2,
          },
        ],
        dueCheckout: false,
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: '0e607152-efef-4df2-991f-e35070857215',
        name: 'Empty Plan',
        installments: [
          {
            percentage: '',
            installmentTotal: '174.00',
            installmentDate: '2025-05-01',
            installmentOrder: 1,
          },
          {
            percentage: '100.00',
            installmentTotal: '4186.14',
            installmentDate: '2026-12-19',
            installmentOrder: 2,
          },
        ],
        dueCheckout: false,
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: 'd92f5c61-9254-47bd-98f2-317e15e712db',
        name: 'Indeed',
        installments: [
          {
            percentage: '100.00',
            installmentTotal: '4360.14',
            installmentDate: '2025-05-05',
            installmentOrder: 1,
          },
        ],
        dueCheckout: true,
      },
      {
        autopayRequired: false,
        ngPaymentPlanId: '64daebba-9801-4bea-b890-b1097f387562',
        name: 'Fungo Bat',
        installments: [
          {
            percentage: '',
            installmentTotal: '200.00',
            installmentDate: '2025-05-11',
            installmentOrder: 1,
          },
          {
            percentage: '30.00',
            installmentTotal: '1248.04',
            installmentDate: '2025-05-17',
            installmentOrder: 2,
          },
          {
            percentage: '70.00',
            installmentTotal: '2912.10',
            installmentDate: '2025-05-23',
            installmentOrder: 3,
          },
        ],
        dueCheckout: true,
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: 'bc389943-a152-4568-9be1-14e35136cef6',
        name: 'Five Installments',
        installments: [
          {
            percentage: '10.00',
            installmentTotal: '436.01',
            installmentDate: '2025-05-16',
            installmentOrder: 1,
          },
          {
            percentage: '23.00',
            installmentTotal: '1002.83',
            installmentDate: '2025-05-17',
            installmentOrder: 2,
          },
          {
            percentage: '11.00',
            installmentTotal: '479.62',
            installmentDate: '2025-05-18',
            installmentOrder: 3,
          },
          {
            percentage: '11.00',
            installmentTotal: '479.62',
            installmentDate: '2025-05-19',
            installmentOrder: 4,
          },
          {
            percentage: '45.00',
            installmentTotal: '1962.06',
            installmentDate: '2025-05-20',
            installmentOrder: 5,
          },
        ],
        dueCheckout: false,
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: '20eaa1c8-bc88-40e4-a790-6a1fab08327b',
        name: 'Oberon',
        installments: [
          {
            percentage: '100.00',
            installmentTotal: '4360.14',
            installmentDate: '2025-06-19',
            installmentOrder: 1,
          },
        ],
        dueCheckout: false,
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: '9e424572-9f28-44fd-a343-51b7c90e5d7e',
        name: 'Urgh',
        installments: [
          {
            percentage: '100.00',
            installmentTotal: '4360.14',
            installmentDate: '2025-06-08',
            installmentOrder: 1,
          },
        ],
        dueCheckout: true,
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: 'd846172d-e02b-4d9b-bcf8-1c0772e054df',
        name: 'Handstand',
        installments: [
          {
            percentage: '28.00',
            installmentTotal: '1355.13',
            installmentDate: '2024-10-15',
            installmentOrder: 1,
          },
          {
            percentage: '72.00',
            installmentTotal: '3484.63',
            installmentDate: '2024-11-16',
            installmentOrder: 2,
          },
        ],
        dueCheckout: true,
        priceAdjustment: {
          percentage: 11,
        },
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: '93ebc8b4-c3cd-4675-8668-eb2703f2b042',
        name: 'Is it true?',
        installments: [
          {
            percentage: '',
            installmentTotal: '176.00',
            installmentDate: '2025-06-02',
            installmentOrder: 1,
          },
          {
            percentage: '56.00',
            installmentTotal: '2611.71',
            installmentDate: '2025-11-15',
            installmentOrder: 2,
          },
          {
            percentage: '22.00',
            installmentTotal: '1026.03',
            installmentDate: '2025-12-21',
            installmentOrder: 3,
          },
          {
            percentage: '22.00',
            installmentTotal: '1026.03',
            installmentDate: '2090-06-03',
            installmentOrder: 4,
          },
        ],
        dueCheckout: true,
        priceAdjustment: {
          percentage: 11,
        },
      },
    ],
    price: '$4,360.14',
    subprograms: [
      {
        subprogramId: 3869229,
        subprogramName: "Cracklin' Bran",
        basePrice: '3860.14',
        currency: 'USD',
        registrations: [
          {
            registrationId: '01981945-0ee2-720b-822a-0a4da27f4def',
            teamName: 'Prism Donkeys',
            registrationType: RegistrationType.Team,
            registeredUserId: 43709703,
            basePrice: '3860.14',
          },
        ],
      },
      {
        subprogramId: 3869271,
        subprogramName: 'Five-1',
        basePrice: '500.00',
        currency: 'USD',
        registrations: [
          {
            registrationId: '01981945-12f1-7ccc-a2af-3f5158e817ff',
            teamName: 'Capybaras',
            registrationType: RegistrationType.Team,
            registeredUserId: 43709703,
            basePrice: '500.00',
          },
        ],
      },
    ],
    subtype: 'team',
    type: 'tournament',
    cartItemName: "David's NG Grouped Tournament",
    iconAltText: "David's NG Grouped Tournament",
    iconUrl:
      'https://svite-league-apps-img-stg.s3.amazonaws.com/program-3869183-s3.jpg',
    location: '10001',
    payInFull: false,
    programDateInfo: 'Jan. 1, 2025 - Oct. 31, 2026',
    programId: 3869183,
    selectedPaymentPlan: {
      autopayRequired: false,
      ngPaymentPlanId: 'ed54a41a-44ee-4817-a633-53f44532d4ab',
      name: 'Costa Rica',
      installments: [
        {
          percentage: '',
          installmentTotal: '200.00',
          installmentDate: '2025-11-13',
          installmentOrder: 1,
        },
        {
          percentage: '100.00',
          installmentTotal: '3200.91',
          installmentDate: '2034-01-05',
          installmentOrder: 2,
        },
      ],
      dueCheckout: false,
      priceAdjustment: {
        percentage: -22,
      },
    },
    dueToday: '200.00',
    totalAmount: '3400.91',
    paymentTerm: 'PAYMENT_PLAN',
    paymentTermLabel: 'Costa Rica',
    description: 'Teams: 2',
  },
  {
    cartItemType: 'TOURNAMENT_TEAM_REGISTRATION',
    cartItemUuid: '01981945-c00b-738f-94d6-5b7a774dd6da',
    editUrl:
      '/app/tournaments/3869179/registration?cartItemUuid=01981945-c00b-738f-94d6-5b7a774dd6da',
    paymentPlanSummaries: [
      {
        autopayRequired: false,
        ngPaymentPlanId: '6c13f40d-6905-4dda-a4c0-f3059f38c23e',
        name: 'Burgermeister',
        installments: [
          {
            percentage: '',
            installmentTotal: '200.00',
            installmentDate: '2025-07-23',
            installmentOrder: 1,
          },
          {
            percentage: '100.00',
            installmentTotal: '4200.00',
            installmentDate: '2027-06-12',
            installmentOrder: 2,
          },
        ],
        dueCheckout: false,
        priceAdjustment: {
          percentage: -20,
        },
      },
      {
        autopayRequired: false,
        dueCheckout: true,
        installments: [],
        name: 'Pay in full',
      },
      {
        autopayRequired: true,
        ngPaymentPlanId: '761f602f-53a4-4bb7-9158-86d7d51f41ec',
        name: 'Single Payment',
        installments: [
          {
            percentage: '100.00',
            installmentTotal: '5500.00',
            installmentDate: '2024-11-07',
            installmentOrder: 1,
          },
        ],
        dueCheckout: true,
      },
    ],
    price: '$5,500.00',
    subprograms: [
      {
        subprogramId: 3869180,
        subprogramName: 'Blue Napkins',
        basePrice: '5000.00',
        currency: 'USD',
        registrations: [
          {
            registrationId: '01981945-bc2c-77f9-b704-798a26110b46',
            teamName: 'Healthy Salad',
            registrationType: RegistrationType.Team,
            registeredUserId: 43709703,
            basePrice: '5000.00',
          },
        ],
      },
      {
        subprogramId: 3871192,
        subprogramName: 'Oligarchy for Dummies',
        basePrice: '500.00',
        currency: 'USD',
        registrations: [
          {
            registrationId: '01981945-bdab-725f-9dfc-3196a784250d',
            teamName: 'Mumbles',
            registrationType: RegistrationType.Team,
            registeredUserId: 43709703,
            basePrice: '500.00',
          },
        ],
      },
    ],
    subtype: 'team',
    type: 'tournament',
    cartItemName: 'Azaleas Not Zebras',
    iconAltText: 'Azaleas Not Zebras',
    iconUrl:
      'https://svite-league-apps-img-stg.s3.amazonaws.com/program-3869179-s3.jpg',
    location: 'Empire State Arena',
    payInFull: true,
    programDateInfo: 'Oct. 2, 2025 - Oct. 24, 2026',
    programId: 3869179,
    selectedPaymentPlan: {
      autopayRequired: false,
      ngPaymentPlanId: '6c13f40d-6905-4dda-a4c0-f3059f38c23e',
      name: 'Burgermeister',
      installments: [
        {
          percentage: '',
          installmentTotal: '200.00',
          installmentDate: '2025-07-23',
          installmentOrder: 1,
        },
        {
          percentage: '100.00',
          installmentTotal: '4200.00',
          installmentDate: '2027-06-12',
          installmentOrder: 2,
        },
      ],
      dueCheckout: false,
      priceAdjustment: {
        percentage: -20,
      },
    },
    dueToday: '200.00',
    totalAmount: '4400.00',
    paymentTerm: 'PAYMENT_PLAN',
    paymentTermLabel: 'Burgermeister',
    description: 'Teams: 2',
  },
];
